const moment = require('moment')
const computed = (value, type) => {
	if (!value){
		return type
	}else if (0 < value && value < 1000){
		return value
	}else if (1000 <= value && value < 1100){
		return '1k'
	}else if (1100 <= value && value < 10000){
		return (value/1000).toFixed(1) + 'k'
	}else if (10000 <= value && value < 11000){
		return '1w'
	}else if (11000 <= value && value < 100000){
		return (value/10000).toFixed(1) + 'w'
	}
}
export default {
	langFilter: value => {
		if (!value) {
			return ''
		} else {
			return value === 'cn' ? '中' : '英'
		}
	},
	templateFilter: value => {
		if (!value) return ''
		if (value.includes('white')) {
			return '经典工作模板'
		} else if (value.includes('stu')) {
			return '学生求职模板'
		} else if (value.includes('zero')) {
			return '零经验模板'
		} else if (value.includes('aboard')) {
			return '留学申请模板'
		} else if (value.includes('bank')) {
			return '投行咨询模板'
		} else if (value.includes('product')) {
			return '产品经理模板'
		} else if (value.includes('programmer')) {
			return '程序员模板'
		} else if (value.includes('grad')) {
			return '申请研究生模板'
		}
	},
	timeFilter: (value, format) => {
		return moment(value).format(format)
	},
	// 会员购买个人中心日期格式化
	personTimeFilter: (value) => {
		let m1 = moment()
		let m2 = moment(value)
		let day = m2.diff(m1,'day')
		if (!value) {
			return '开通会员享受更多特权'
		} else if (day >= 33000) {
			return '您已是超级简历终身Plus会员'
		} else if (day >= 15000) {
			return '您已是超级简历终身会员'
		}else if (day < 0) {
			return '超级会员：已过期'
		}else {
			return '您已成为超级简历会员，到期时间 ' + moment(value).format('YYYY年MM月DD日')
		}
	},
	timeFormatFilter: (value, hasTime) => {
		let today = moment().format('YYYYMMDD')
		let update = moment(value).format('YYYYMMDD')
		let year = moment().year()
		let updateYear = moment(value).year()
		let now = moment().format('YYYYMMDDHHmm')
		let updateMoment = moment(value).format('YYYYMMDDHHmm')
		// 大于当前时间显示为空
		if (updateMoment > now) {
			return ''
		}else if (today === update) {
			return moment(value).format('HH:mm')
		} else if (update - 0 === today - 1) {
			return hasTime ? `昨天 ${ moment(value).format('HH:mm') }` : '昨天'
		} else if (update < today - 1 && year === updateYear) {
			return moment(value).format('MM月DD日')
		} else if (updateYear < year) {
			return moment(value).format('YYYY年MM月DD日')
		}else {
			return ''
		}
	},
	// 动态详情页时间格式化
	articleTimeFormatFilter: (value, hasTime) => {
		let today = moment().format('YYYYMMDD')
		let update = moment(value).format('YYYYMMDD')
		let year = moment().year()
		let updateYear = moment(value).year()
		let now = moment().format('YYYYMMDDHHmm')
		let updateMoment = moment(value).format('YYYYMMDDHHmm')
		// 大于当前时间显示为空
		if (updateMoment > now) {
			return ''
		}else if (today === update) {
			return moment(value).format('HH:mm')
		} else if (update - 0 === today - 1) {
			return `昨天 ${ moment(value).format('HH:mm') }`
		} else if (update < today - 1 && year === updateYear) {
			// return moment(value).format('MM-DD HH:mm')
			return moment(value).format('MM-DD')
		} else if (updateYear < year) {
			// return moment(value).format('YYYY-MM-DD HH:mm')
			return moment(value).format('YYYY-MM-DD')
		}else {
			return ''
		}
	},
	// 评论、收藏、点赞数量格式化
	countFilter: (value, type) => {
		if (type === 'comment'){
			return computed(value,'评论')
		}else if (type === 'collection'){
			return computed(value,'收藏')
		}else if (type === 'like'){
			return computed(value,'赞')
		}else {
			return computed(value,'')
		}
	},

	// 邀请页的邀请时间格式化
	inviteTimeFormat: value => {
		let year = moment().year()
		let updateYear = moment(value).year()
		if (year === updateYear) {
			return moment(value).format('MM-DD')
		} else {
			return moment(value).format('YYYY-MM-DD')
		}
	},

	// 隐藏基本信息--基本信息格式化
	hideMessageFormat: (value, isHide) => {
		if (!value) {
			return '姓名'
		}
		if (isHide) {
			return new Array(value.length + 1).join('*')
		} else {
			return value
		}
	},
}
